import { absolutePath } from "./absolutePath";

export const emailHub = {
  onboarding: {
    check: () => absolutePath("email_hub/onboarding"),
    getPopularWorkflowTemplates: () =>
      absolutePath("email_hub/onboarding/popular_workflow_templates"),
    getRecentlyUpdated: () =>
      absolutePath("email_hub/onboarding/recently_updated_resources?limit=4"),
    updateChecklist: () => absolutePath("email_hub/onboarding"),
  },
  themes: {
    index: () => absolutePath("email_hub/themes"),
    show: ({ themeId }: { themeId: number }) =>
      absolutePath(`email_hub/themes/${themeId}`),
    create_custom_theme: () =>
      absolutePath("email_hub/themes/create_custom_theme"),
    upsert_custom_theme: () =>
      absolutePath("email_hub/themes/upsert_custom_theme"),
    update: ({ themeId }: { themeId: number }) =>
      absolutePath(`email_hub/themes/${themeId}`),
    replace_and_delete: ({ themeId }: { themeId: number }) =>
      absolutePath(`email_hub/themes/${themeId}/replace_and_delete`),
  },
};
